import React from 'react';
import TextField from '@material-ui/core/TextField';
import {useSelector, useDispatch} from 'react-redux'
import {checkKundNr} from 'actions'
import IntlMessages from 'util/IntlMessages';
function Kundnr(props) {
    const dispatch = useDispatch()
    const isCheckedOk = useSelector(state=>state.accountsData.isCheckedOk)
    const [value, setValue]=React.useState(props.Kundnr)
    const onChangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=(e)=>{
        props.onChangeKund("Kundnr",value)
        dispatch(checkKundNr(props.Afid,value))
    }
    return (
        <div>
           <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="Customer.Nr"/>}
           error={parseInt(isCheckedOk) === 1}
           value={value}
           onChange={onChangeHandle}
           onBlur={onBlurHandle}
           InputLabelProps={{ shrink: true }}
           /> 
        </div>
    );
}

export default Kundnr;